var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",attrs:{"category":_vm.data,"slug":_vm.slug,"type":_vm.type}})
}
var staticRenderFns = []

export { render, staticRenderFns }